import { memo } from "react";
import AddRemoveRejectApproveModal from "./AddRemoveRejectApproveModal";
import { DocumentPreviewEditHeaderPanel } from "./DocumentPreviewEditHeaderPanel";
import { DocumentPreviewEditModalTablePanel } from "./DocumentPreviewEditModalTablePanel";

const DocumentPreviewEditContent: React.FC = () => {
    return <div className={`main-comp-wrapper`} style={{ width: "60vw", height: "78vh" }}>
        <DocumentPreviewEditHeaderPanel />
        <DocumentPreviewEditModalTablePanel />
        <div className='im-charge-data-search-confirm-modal-container'>
            {<AddRemoveRejectApproveModal />}
        </div>
    </div>
}

export default memo(DocumentPreviewEditContent);